import { render, staticRenderFns } from "./MenuList.vue?vue&type=template&id=3acca1e2&scoped=true&"
import script from "../../models/menu-management/menu-list.ts?vue&type=script&lang=ts&"
export * from "../../models/menu-management/menu-list.ts?vue&type=script&lang=ts&"
import style0 from "./MenuList.vue?vue&type=style&index=0&id=3acca1e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acca1e2",
  null
  
)

export default component.exports